export const viR = {
    religion: {
        list: { title: 'Danh sách Tôn Giáo' },
        form: {
            updateTitle: 'Chỉnh sửa Tôn Giáo',
            insertTitle: 'Thêm mới Tôn Giáo'
        }
    },
    resource: {
        list: { title: 'Danh sách Nguồn Khách' }
    },
    role: {
        list: { title: 'Danh sách Nhóm Quyền' },
        form: {
            groupname: 'Tên Nhóm Quyền',
            titleInfo: 'Thông tin Nhóm Quyền',
            edit: 'Chỉnh sửa nhóm quyền'
        }
    },
    request: {
        form: {
            details: 'Chi tiết phiếu',
            insertTitle: 'Tạo mới đơn hàng',
            updateTitle: 'Chỉnh sửa đơn hàng',
            exportVAT: 'In hóa đơn VAT'
        },
        list: { edit: 'Chỉnh sửa/ Tạo phiếu yêu cầu' }
    },
    report: {
        reportCommissione: 'Báo cáo về hoa hồng của nhân viên',
        listCustomerServiceCard:
            'Báo cáo doanh thu của thẻ dịch vụ khách hàng',
        customerPoints: 'Báo cáo tích điểm',
        serviceAppointmentReport: 'Báo cáo Đặt hẹn dịch vụ',
        staffAppointment: 'Báo cáo Đặt lịch hẹn nhân viên',
        listTotal: 'Báo cáo tổng doanh thu',
        listTotalDetailService: 'Doanh thu chi tiết dịch vụ',
        listTotalDetailProduct: 'Doanh thu chi tiết sản phẩm',
        listTotalDetailCustomer: 'Doanh thu chi tiết khách hàng',
        listReport: 'Báo cáo doanh thu',
        countServicesProducts: 'Báo cáo doanh thu số lần dịch vụ/ sản phẩm',
        customerServiceDetail: 'Báo cáo chi tiết dịch vụ khách hàng theo ngày giờ',
        listWarehouseCard: 'Báo cáo thẻ kho',
        firstTimeCustomer: 'Báo cáo khách hàng sử dụng dịch vụ lần đầu',
        listImportExport: 'Báo cáo nhập xuất tồn',
        listProductInventory: 'Báo cáo sản phẩm tồn kho',
        listUser: 'Báo cáo nhân viên',
        listUserDetail: 'Báo cáo nhân viên chi tiết',
        listServiceProduct: 'Báo cáo dịch vụ/ sản phẩm',
        listCustomerCard: 'Báo cáo mua thẻ trả trước',
        listProductGroup: 'Báo cáo doanh thu theo nhóm sản phẩm',
        detail: 'Chi tiết',
        Service: 'dịch vụ',
        Product: 'sản phẩm',
        Price: 'Tổng doanh thu',
        Discount: 'Giảm giá',
        Amount: 'Doanh thu thuần',
        CustomerServiceCard: 'Thu tiền bán thẻ trả trước',
        Total: 'Tổng tiền thu được từ',
        TotalUse: 'Số tiền đã sử dụng',
        TotalBalance: 'Số tiền còn lại',
        TotalPaid: 'Số tiền đã TT',
        percent: 'Phần trăm',
        commissioneMoney: 'Tiền hoa hồng',
        joinedDate: 'Ngày ',
        serviceCount: 'Số lần DV',
        productCount: 'Số lần SP',
        totalAmountService: 'Tổng tiền DV',
        totalAmountProduct: 'Tổng tiền SP',
        exportExcel: 'Xuất excel',
        exportAll: 'Xuất tất cả',
        totalPrice: 'Tổng doanh thu',
        totalAmount: 'Thành tiền',
        employee: 'Nhân viên thực hiện',
        customersReport: 'Báo cáo khách hàng',
        explain: 'Diễn giải',
        error: {
            selectUser: 'Chưa chọn nhân viên'
        },
        detailPayment: {
            listTitle: 'Báo cáo chi tiết thanh toán',
            customerCode: 'Mã KH',
            fullName: 'Khách hàng',
            birthday: 'Ngày sinh',
            phoneNumber: 'Số điện thoại',
            type: 'Loại',
            creatorFullName: 'Người thu',
            pageUnit: 'bản ghi',
            cardType: 'Loại thẻ',
            paidCustomerCode: 'Mã KH TT',
            paidCustomerName: 'Tên KH TT',
            totalValue: 'Tổng tiền',
            invoiceDate: 'Ngày thu'
        }
    }
};
